export const INITIAL_CONTEXT_MODEL_STATE = {
    project: {},
    variables: {},
    globals: {},
    inputs: {}
};

export const RBR_INITIAL_CONTEXT_MODEL_STATE = {
    project: {
        projectType: 'NEW_BUILDING',
        salesforceProjectId: '3000234834',
        salesforceOpportunityId: '0069Z00000dHCBDQA4',
        currencyCode: 'EUR',
        countryCode: 'DE',
        vatRate: 0.19,
        languageCode: 'en',
        salesOrganization: '0500',
        createdDate: '2026-05-19T04:55:38.000Z',
        createdBy: 'VPlus Silver Layer 2 Layer 2',
        createdById: '9f27258e-5007-42dc-af12-a6b42afe5e75',
        createdByLogin: 'vplus-silver@viessmann-climatesolutions.com',
        energyPrices: [],
        variants: [],
        building: {
            id: 'a2g9Z000004Op2HQAS',
            buildingType: 'ONE_FAMILY_HOUSE',
            numberOfPersons: 4,
            thermalRecovery: 0,
            livingArea: 120,
            buildingLevelHeight: 2.5,
            hasVentilation: false,
            electricityDemand: 4500,
            totalElectricityDemand: 4500,
            installer: {
                partnerNumber: '1200031489',
                languageCode: 'DE',
                email: 'vplus-silver@viessmann-climatesolutions.com',
                phone: '+49456453456456',
                companyName: 'V+ Silver Testaccount',
                salesOrganization: '0500',
                id: '0011i000002s81YAAQ',
                streetName: 'Viessmannstr.',
                houseNumber: '1',
                postalCode: '35108',
                city: 'Allendorf (Eder)',
                countryCode: 'DE'
            },
            heatLoadCalculations: [
                {
                    orderDate: '2026-05-19T04:58:11.254Z',
                    isSelected: true,
                    method: 'ROOM_BY_ROOM',
                    baseHeatLoad: 4.481408,
                    warmWaterHeatLoad: 0,
                    baseHeatDemand: 7640.56031813104,
                    baseCoolingLoad: 5.763280000000001,
                    roomCalculations: {
                        '1884b1a0-e757-4567-b2c7-a5ef95814c36': {
                            roomId: '1884b1a0-e757-4567-b2c7-a5ef95814c36',
                            baseHeatLoad: 0.881408,
                            baseHeatDemand: 1502.753373244133,
                            baseCoolingLoad: 0.96328,
                            isActive: true
                        },
                        '36927ee6-8814-4688-861d-93aa62b62166': {
                            roomId: '36927ee6-8814-4688-861d-93aa62b62166',
                            baseHeatLoad: 0.675,
                            baseHeatDemand: 1150.838802166295,
                            baseCoolingLoad: 0.9,
                            isActive: true
                        },
                        '50887cd2-b619-452a-9c94-c9a175df5044': {
                            roomId: '50887cd2-b619-452a-9c94-c9a175df5044',
                            baseHeatLoad: 0.54,
                            baseHeatDemand: 920.671041733036,
                            baseCoolingLoad: 0.72,
                            isActive: true
                        },
                        '08039a85-0beb-46a2-8742-54d99e14ea52': {
                            roomId: '08039a85-0beb-46a2-8742-54d99e14ea52',
                            baseHeatLoad: 0.495,
                            baseHeatDemand: 843.9484549219496,
                            baseCoolingLoad: 0.66,
                            isActive: true
                        },
                        'de9a73b0-f7e7-4902-864e-787b01c95fb0': {
                            roomId: 'de9a73b0-f7e7-4902-864e-787b01c95fb0',
                            baseHeatLoad: 0.9,
                            baseHeatDemand: 1534.4517362217266,
                            baseCoolingLoad: 1.2,
                            isActive: true
                        },
                        '7b5091e6-3632-42e7-a483-20c7f117e796': {
                            roomId: '7b5091e6-3632-42e7-a483-20c7f117e796',
                            baseHeatLoad: 0.99,
                            baseHeatDemand: 1687.8969098438993,
                            baseCoolingLoad: 1.32,
                            isActive: true
                        },
                        'leftover-area': {
                            roomId: 'leftover-area',
                            baseHeatLoad: 0.9,
                            baseHeatDemand: 2191.38964329721,
                            baseCoolingLoad: 0,
                            isActive: false
                        }
                    }
                }
            ],
            standardTypeOfSunProtection: 'BETWEEN_GLASS',
            standardTypeOfWindow: 'DOUBLE_GLAZING',
            rooms: {
                'de9a73b0-f7e7-4902-864e-787b01c95fb0': {
                    id: 'de9a73b0-f7e7-4902-864e-787b01c95fb0',
                    name: 'myBEDROOM',
                    type: 'BEDROOM',
                    slabIds: ['2braqUNJghEq', 'YkZnTqSdvpBV'],
                    levelIds: ['ffe157ff-68cd-4280-8599-75a7c3b02a32'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '7b5091e6-3632-42e7-a483-20c7f117e796': {
                    id: '7b5091e6-3632-42e7-a483-20c7f117e796',
                    name: 'BEDROOM',
                    type: 'BEDROOM',
                    slabIds: ['AcT1WdWtqzAi', 'RUGytMRfaqdI'],
                    levelIds: ['ecee84cc-0f28-4cb0-9f74-3dd0f99472b7'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '1884b1a0-e757-4567-b2c7-a5ef95814c36': {
                    id: '1884b1a0-e757-4567-b2c7-a5ef95814c36',
                    name: 'BEDROOM',
                    type: 'BEDROOM',
                    wallIds: ['D8F5uPk5C0mm'],
                    slabIds: ['KlMX6ZmL5Gla', 'aHSeZ8iNpWQB'],
                    levelIds: ['ecee84cc-0f28-4cb0-9f74-3dd0f99472b7'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: true,
                    heatSources: [
                        {
                            type: 'DEVICE_COFFEE_MACHINE',
                            connectedLoad: 200,
                            amount: 1
                        },
                        {
                            type: 'DEVICE_DRYER_CONDENSER',
                            amount: 1
                        }
                    ],
                    residents: [
                        {
                            type: 'HUMAN_ADULT',
                            connectedLoad: 0.08,
                            amount: 2
                        },
                        {
                            type: 'HUMAN_CHILD_PRESCHOOL',
                            connectedLoad: 0.04,
                            amount: 0
                        }
                    ]
                },
                '50887cd2-b619-452a-9c94-c9a175df5044': {
                    id: '50887cd2-b619-452a-9c94-c9a175df5044',
                    name: 'CHILDREN_ROOM',
                    type: 'CHILDREN_ROOM',
                    slabIds: ['GeUfOKoNsYzr', 'Xog4t9nDi8gz'],
                    levelIds: ['ecee84cc-0f28-4cb0-9f74-3dd0f99472b7'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: true
                },
                '08039a85-0beb-46a2-8742-54d99e14ea52': {
                    id: '08039a85-0beb-46a2-8742-54d99e14ea52',
                    name: 'CHILDREN_ROOM',
                    type: 'BEDROOM',
                    slabIds: ['tjPmS4G81pGi', 'ObcmRbcDY5N1'],
                    levelIds: ['ecee84cc-0f28-4cb0-9f74-3dd0f99472b7'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '36927ee6-8814-4688-861d-93aa62b62166': {
                    id: '36927ee6-8814-4688-861d-93aa62b62166',
                    name: 'KITCHEN',
                    type: 'KITCHEN',
                    slabIds: ['ZMYNzJza8wor', '2vLtLBnqNd2A'],
                    levelIds: ['ecee84cc-0f28-4cb0-9f74-3dd0f99472b7'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: true
                },
                'ed52062b-6989-4451-9645-e926c7d6740d': {
                    id: 'ed52062b-6989-4451-9645-e926c7d6740d',
                    name: 'BATHROOM',
                    type: 'BATHROOM',
                    levelIds: ['ecee84cc-0f28-4cb0-9f74-3dd0f99472b7'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '7893301f-ac3c-4976-b270-b0e785094f27': {
                    id: '7893301f-ac3c-4976-b270-b0e785094f27',
                    name: 'OFFICE_ROOM',
                    type: 'OFFICE_ROOM',
                    levelIds: ['f299018d-5b30-46ce-9622-d9404e47d330'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '53873714-04fe-47f9-a36c-be110810e2e9': {
                    id: '53873714-04fe-47f9-a36c-be110810e2e9',
                    name: 'LIVING_ROOM',
                    type: 'LIVING_ROOM',
                    levelIds: ['f299018d-5b30-46ce-9622-d9404e47d330'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '380b2cd3-87ba-4d71-9742-08b9394bb082': {
                    id: '380b2cd3-87ba-4d71-9742-08b9394bb082',
                    name: 'HALL',
                    type: 'HALL',
                    levelIds: ['f299018d-5b30-46ce-9622-d9404e47d330'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '34589181-8257-4ca6-87ec-1c02e7207b1c': {
                    id: '34589181-8257-4ca6-87ec-1c02e7207b1c',
                    name: 'WC',
                    type: 'WC',
                    levelIds: ['f299018d-5b30-46ce-9622-d9404e47d330'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                },
                '028fbc39-3a39-469b-bc01-e24a98a32680': {
                    id: '028fbc39-3a39-469b-bc01-e24a98a32680',
                    name: 'UTILITY_ROOM',
                    type: 'UTILITY_ROOM',
                    levelIds: ['f299018d-5b30-46ce-9622-d9404e47d330'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false
                }
            },
            walls: {
                D8F5uPk5C0mm: {
                    id: 'D8F5uPk5C0mm',
                    orientation: 'NORTH',
                    windowIds: ['0027USsnro5J'],
                    zones: [
                        {
                            id: 'WALL_ZONE',
                            adjacentTo: {
                                type: 'EXTERNAL'
                            },
                            area: 40
                        }
                    ]
                }
            },
            windows: {
                '0027USsnro5J': {
                    id: '0027USsnro5J',
                    typeOfSunProtection: 'BETWEEN_GLASS',
                    area: 2,
                    type: 'DOUBLE_GLAZING'
                }
            },
            slabs: {
                '2braqUNJghEq': {
                    id: '2braqUNJghEq',
                    type: 'FLOOR',
                    zones: [
                        {
                            id: 'FLOOR_ZONE',
                            area: 20
                        }
                    ]
                },
                YkZnTqSdvpBV: {
                    id: 'YkZnTqSdvpBV',
                    type: 'CEILING',
                    zones: [
                        {
                            id: 'CEILING_ZONE'
                        }
                    ]
                },
                AcT1WdWtqzAi: {
                    id: 'AcT1WdWtqzAi',
                    type: 'FLOOR',
                    zones: [
                        {
                            id: 'FLOOR_ZONE',
                            area: 22
                        }
                    ]
                },
                RUGytMRfaqdI: {
                    id: 'RUGytMRfaqdI',
                    type: 'CEILING',
                    zones: [
                        {
                            id: 'CEILING_ZONE'
                        }
                    ]
                },
                KlMX6ZmL5Gla: {
                    id: 'KlMX6ZmL5Gla',
                    type: 'FLOOR',
                    zones: [
                        {
                            id: 'FLOOR_ZONE',
                            adjacentTo: {
                                type: 'GROUND'
                            },
                            area: 20
                        }
                    ]
                },
                aHSeZ8iNpWQB: {
                    id: 'aHSeZ8iNpWQB',
                    type: 'CEILING',
                    zones: [
                        {
                            id: 'CEILING_ZONE',
                            area: 20
                        }
                    ]
                },
                GeUfOKoNsYzr: {
                    id: 'GeUfOKoNsYzr',
                    type: 'FLOOR',
                    zones: [
                        {
                            id: 'FLOOR_ZONE',
                            area: 12
                        }
                    ]
                },
                Xog4t9nDi8gz: {
                    id: 'Xog4t9nDi8gz',
                    type: 'CEILING',
                    zones: [
                        {
                            id: 'CEILING_ZONE'
                        }
                    ]
                },
                tjPmS4G81pGi: {
                    id: 'tjPmS4G81pGi',
                    type: 'FLOOR',
                    zones: [
                        {
                            id: 'FLOOR_ZONE',
                            area: 11
                        }
                    ]
                },
                ObcmRbcDY5N1: {
                    id: 'ObcmRbcDY5N1',
                    type: 'CEILING',
                    zones: [
                        {
                            id: 'CEILING_ZONE'
                        }
                    ]
                },
                ZMYNzJza8wor: {
                    id: 'ZMYNzJza8wor',
                    type: 'FLOOR',
                    zones: [
                        {
                            id: 'FLOOR_ZONE',
                            area: 15
                        }
                    ]
                },
                '2vLtLBnqNd2A': {
                    id: '2vLtLBnqNd2A',
                    type: 'CEILING',
                    zones: [
                        {
                            id: 'CEILING_ZONE'
                        }
                    ]
                }
            },
            levels: {
                'e122cc36-06f5-4956-80a8-b92cac136688': {
                    id: 'e122cc36-06f5-4956-80a8-b92cac136688',
                    name: 'Obergeschoss 3',
                    number: 3
                },
                'ffe157ff-68cd-4280-8599-75a7c3b02a32': {
                    id: 'ffe157ff-68cd-4280-8599-75a7c3b02a32',
                    name: 'Upper level 2',
                    number: 2
                },
                'ecee84cc-0f28-4cb0-9f74-3dd0f99472b7': {
                    id: 'ecee84cc-0f28-4cb0-9f74-3dd0f99472b7',
                    name: '',
                    number: 1
                },
                'f299018d-5b30-46ce-9622-d9404e47d330': {
                    id: 'f299018d-5b30-46ce-9622-d9404e47d330',
                    name: '',
                    number: 0
                }
            }
        },
        viguidePlanningSpecificData: {
            applicationVersion: '2.40.0',
            apiVersion: '1.40.0'
        },
        id: 'a2g9Z000004Op2HQAS',
        projectName: 'RbR - demo 19/05',
        projectStatus: 'DESIGN',
        lastChangeDate: '2026-06-12T07:43:01.000Z',
        lastChangeBy: 'VPlus Silver Layer 2 Layer 2',
        lastChangeById: '9f27258e-5007-42dc-af12-a6b42afe5e75',
        lastChangeByLogin: 'vplus-silver@viessmann-climatesolutions.com',
        address: {
            id: 'a2v1i0000008tJTAAY',
            streetName: 'Viessmannstr.',
            houseNumber: '1',
            postalCode: '35108',
            city: 'Allendorf (Eder)',
            countryCode: 'DE'
        },
        tags: []
    },
    variables: {},
    globals: {},
    inputs: {
        selectedRoomId: 'de9a73b0-f7e7-4902-864e-787b01c95fb0'
    }
};
